import { answerModalActionTypes } from './Constants';

export function setAnswerModal(data) {
	return {
		type: answerModalActionTypes.SET_ANSWER_MODAL,
		payload: { data },
	};
}

export function uploadImageRequest(file, questionId) {
	return {
		type: answerModalActionTypes.UPLOAD_ANSWER_ATTACHMENT_REQUEST,
		payload: {
			file,
			questionId,
		},
	};
}

export function uploadImageSuccess(publicLink, fileName) {
	return {
		type: answerModalActionTypes.UPLOAD_ANSWER_ATTACHMENT_SUCCESS,
		payload: {
			publicLink,
			fileName,
		},
	};
}

export function uploadImageError() {
	return {
		type: answerModalActionTypes.UPLOAD_ANSWER_ATTACHMENT_ERROR,
	};
}

export function createAnswerRequest(data, questionId, answerUserId) {
	return {
		type: answerModalActionTypes.CREATE_ANSWER_REQUEST,
		payload: {
			data,
			questionId,
			answerUserId,
		},
	};
}

export function createAnswerSuccess() {
	return {
		type: answerModalActionTypes.CREATE_ANSWER_SUCCESS,
		payload: {},
	};
}

export function createAnswerError() {
	return {
		type: answerModalActionTypes.CREATE_ANSWER_ERROR,
		error: true,
	};
}

export function updateAnswerRequest(data, questionId, answerId) {
	return {
		type: answerModalActionTypes.UPDATE_ANSWER_REQUEST,
		payload: {
			data,
			questionId,
			answerId,
		},
	};
}

export function updateAnswerSuccess() {
	return {
		type: answerModalActionTypes.UPDATE_ANSWER_SUCCESS,
		payload: {},
	};
}

export function updateAnswerError() {
	return {
		type: answerModalActionTypes.UPDATE_ANSWER_ERROR,
		error: true,
	};
}

export function clearState() {
	return {
		type: answerModalActionTypes.CLEAR_ANSWER_STATE,
	};
}
